import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  Skeleton,
  Alert,
} from '@mui/material';
import AvatarCard from '../components/AvatarCard';
import AvatarFilters from '../components/AvatarFilters';
import EmptyState from '../components/EmptyState';
import ErrorState from '../components/ErrorState';
import { getAvatars } from '../../../apis/apiList/publicAiStudioApi';

const SelectAvatarStep = ({ selectedAvatar, onSelectAvatar }) => {
  const [avatars, setAvatars] = useState([]);
  const [filters, setFilters] = useState({
    style: 'all',
    gender: '',
    accent: '',
    search: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [accents, setAccents] = useState([]);

  useEffect(() => {
    fetchAvatars();
  }, [filters]);

  useEffect(() => {
      const handleScroll = () => {
        console.log("scroll fired");
    console.log("window.scrollY =", window.scrollY);
        window.parent.postMessage(
          {
            type: "iframe-scroll",
            scrollY: window.scrollY
          },
          "https://associationstudios.com"
        );
      };
  
      window.addEventListener("scroll", handleScroll);
  
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  

  const fetchAvatars = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getAvatars(filters);
      const avatarsData = Array.isArray(response) ? response : response?.data || [];
      setAvatars(avatarsData);

      if (avatarsData.length) {
        const uniqueAccents = [
          ...new Set(
            avatarsData
              .map((a) => a.accent)
              .filter(Boolean)
          ),
        ];
        setAccents(uniqueAccents);
      }
    } catch (err) {
      console.error('Failed to fetch avatars:', err);
      setError(err.message || 'Failed to load avatars');
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  if (error) {
    return (
      <ErrorState
        title="Failed to Load Avatars"
        message={error}
        onRetry={fetchAvatars}
      />
    );
  }

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Select Your Avatar
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Choose an avatar that best represents your brand or message
      </Typography>

      <AvatarFilters
        filters={filters}
        onFilterChange={handleFilterChange}
        accents={accents}
      />

      {!selectedAvatar && (
        <Alert severity="info" sx={{ mb: 3 }}>
          Please select an avatar to continue to the next step
        </Alert>
      )}

      {loading ? (
        <Grid container spacing={3}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => (
            <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={i}>
              <Skeleton variant="rectangular" height={280} sx={{ borderRadius: 2 }} />
              <Skeleton variant="text" sx={{ mt: 1 }} />
              <Skeleton variant="text" width="60%" />
            </Grid>
          ))}
        </Grid>
      ) : avatars.length === 0 ? (
        <EmptyState
          type="no-results"
          message="No Avatars Found"
          subtitle="Try adjusting your filters to see more avatars"
        />
      ) : (
        <>
          <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              Showing {avatars.length} avatars
            </Typography>
          </Box>

          <Grid container spacing={3} sx={{ mb: '50px' }}>
            {avatars.map((avatar) => (
              <Grid item xs={12} sm={6} md={4} lg={4} xl={3} key={avatar._id}>
                <AvatarCard
                  avatar={avatar}
                  isSelected={selectedAvatar?._id === avatar._id}
                  onSelect={onSelectAvatar}
                />
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </Box>
  );
};

export default SelectAvatarStep;
